import { useSyncExternalStore } from "react";

// Apariencia: "auto" (sigue al sistema), "light" u "dark".
// Se guarda solo en este dispositivo (localStorage) y se aplica con la clase
// `dark` en <html>, que redefine las variables de color de index.css.
const KEY = "rh_theme";

// Color de marca por defecto (el propietario puede cambiarlo en Ajustes → Aplicación).
export const DEFAULT_BRAND_COLOR = "#0062E0";

export function getThemeMode() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "auto";
  } catch {
    return "auto";
  }
}

function systemPrefersDark() {
  return !!(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);
}

export function applyTheme(mode = getThemeMode()) {
  const dark = mode === "dark" || (mode === "auto" && systemPrefersDark());
  const root = document.documentElement;
  root.classList.toggle("dark", dark);
  root.style.colorScheme = dark ? "dark" : "light";
  const metas = document.querySelectorAll('meta[name="theme-color"]');
  if (metas.length) {
    const brand = getComputedStyle(root).getPropertyValue("--brand-fill").trim();
    metas.forEach((m) => {
      m.removeAttribute("media");
      m.setAttribute("content", dark ? "#000000" : brand || DEFAULT_BRAND_COLOR);
    });
  }
}

export function setThemeMode(mode) {
  try {
    if (mode === "auto") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, mode);
  } catch {
    /* sin almacenamiento: se aplica solo en esta sesión */
  }
  applyTheme(mode);
}

export function initTheme() {
  applyTheme();
  if (window.matchMedia) {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => { if (getThemeMode() === "auto") applyTheme("auto"); };
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
}

// true mientras <html> lleva la clase `dark` (se actualiza al cambiar el tema).
function subscribeDark(cb) {
  const obs = new MutationObserver(cb);
  obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  return () => obs.disconnect();
}
export function useDarkClass() {
  return useSyncExternalStore(
    subscribeDark,
    () => document.documentElement.classList.contains("dark"),
    () => false,
  );
}
